export default __webpack_public_path__ + "static/media/slider_click_icon.f383902d.svg";